import AService from '@/services/AService';
import ExportService from '@/services/ExportService';

export default class SettingsService extends AService {

  async exportEventDataAsCSVs(){
    const response = await this.http.get(`${this.baseUrl}/export/eventDataAsCSVs`, {responseType: 'blob'})
    const exportService = new ExportService();
    exportService.exportEventData(response);
  }

  async deleteEventData(){
    const response = await this.http.delete(`${this.baseUrl}/event/data`);
  }
}
